/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteIntegrationEventModal_integrationEvent$ref: FragmentReference;
declare export opaque type DeleteIntegrationEventModal_integrationEvent$fragmentType: DeleteIntegrationEventModal_integrationEvent$ref;
export type DeleteIntegrationEventModal_integrationEvent = {|
  +id: string,
  +eventType: {|
    +id: string,
    +cosmeticName: string,
  |},
  +$refType: DeleteIntegrationEventModal_integrationEvent$ref,
|};
export type DeleteIntegrationEventModal_integrationEvent$data = DeleteIntegrationEventModal_integrationEvent;
export type DeleteIntegrationEventModal_integrationEvent$key = {
  +$data?: DeleteIntegrationEventModal_integrationEvent$data,
  +$fragmentRefs: DeleteIntegrationEventModal_integrationEvent$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "DeleteIntegrationEventModal_integrationEvent",
  "type": "IntegrationEvent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "eventType",
      "storageKey": null,
      "args": null,
      "concreteType": "EventType",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cosmeticName",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '801506b63bff8aec058594fa80d53a82';
module.exports = node;
